<template>
  <div class="selected-communities">
    <h2 v-if="displayIsMobile" class="title pb-2">
      <button
        class="selected-communities__btn"
        :aria-expanded="`${showDetails}`"
        @click.prevent="onToggleDisplay"
      >
        Community Hubs
        <v-icon
          class="selected-communities__expand-icon mt-1"
          color="primary"
          >{{ showDetails ? mdiChevronUp : mdiChevronDown }}</v-icon
        >
      </button>
    </h2>
    <h2 v-else class="title">Community Hubs</h2>

    <ContainerGrid>
      <LayoutItems
        v-if="showDetails"
        :items="communities"
        component-name="CommunityOverview"
        cols="12"
        sm="6"
        md="6"
        lg="4"
      />
    </ContainerGrid>
  </div>
</template>

<script>
import { mdiChevronUp, mdiChevronDown } from "@mdi/js";
import ContainerGrid from "~/components/layout/ContainerGrid";
import LayoutItems from "~/components/layout/LayoutItems";

import { displayIsMobile } from "~/components/utilities/displayBreakpoints";

export default {
  name: "SelectedCommunities",
  components: {
    ContainerGrid,
    LayoutItems,
  },
  props: {
    communities: { type: Array, default: () => [] },
  },
  data() {
    return {
      showDetails: true,
      // Icon
      mdiChevronDown,
      mdiChevronUp,
    };
  },
  computed: {
    displayIsMobile,
  },
  methods: {
    onToggleDisplay() {
      this.showDetails = !this.showDetails;
    },
  },
};
</script>

<style lang="scss">
.selected-communities {
  width: 100%;
  text-align: left;

  &__btn {
    width: 100%;
    text-align: left;
  }

  &__expand-icon {
    float: right;
  }
}
</style>
